var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"join-container",on:{"click":function($event){return _vm.$router.push('/about')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }